<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8">
    <div class="mb-6 mx-auto max-w-screen-xl px-4 sm:px-6" v-if="isAdmin">
      <div class="text-center">
        <h2
          class="text-2xl tracking-wider leading-10 font-semibold  text-white mt-4 sm:text-5xl sm:leading-none md:text-4xl"
        >
          Unapproved
        </h2>
      </div>
    </div>
    <div class="bg-white shadow overflow-hidden sm:rounded-md" v-if="isAdmin">
      <ul>
        <li
          v-for="(topic, idx) in unapproved"
          :key="idx"
          v-bind:class="{ 'border-t border-green': idx > 0 }"
        >
          <topic-approval-row :topic="topic"></topic-approval-row>
        </li>
      </ul>
    </div></div
></template>

<script>
import { topicsCollection } from "../utils/firebase";
import { mapGetters } from "vuex";
import TopicApprovalRow from "../components/TopicApprovalRow";

export default {
  name: "TopicApproval",
  data() {
    return {
      subscription: null,
      unapproved: []
    };
  },
  components: {
    TopicApprovalRow
  },
  created() {
    this.subscription = this.fetchUnapprovedTopics();
  },
  methods: {
    fetchUnapprovedTopics() {
      this.topics = [];
      const subscription = topicsCollection
        .where("approved", "==", false)
        .orderBy("timestamp", "desc")
        .onSnapshot(querySnapshot => {
          this.unapproved = [];
          querySnapshot.forEach(doc => {
            this.unapproved.push({ id: doc.id, ...doc.data() });
          });
        });
      return subscription;
    }
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription();
    }
  },
  computed: {
    ...mapGetters(["loggedIn", "isAdmin"])
  }
};
</script>

<style scoped></style>
